<template>
    <v-card>
        <v-data-table
            :loading="reportTableLoading"
            :headers="headers"
            :items="guestReportData"
            :server-items-length="total"
            :options.sync="options"
            :hide-default-footer="hideFooter"
            :footer-props="getFooterProps()"
        >
            <template v-slot:item.avgBookedDays="{item}">
                {{ parseFloat(item.avgBookedDays).toFixed(1)}}
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
export default {
    name: "GuestReportTable",

    props: {
        limit: {
            type: Number,
            required: false,
        },
        hideFooter: {
            type: Boolean,
            default: false,
        },
        hideQuery: {
            type: Boolean,
            default: false,
        }
    },

    data: () => ({
        guestReportData: [],
        reportTableLoading: '',
        total: 0,
        query: '',
        filter: {},
        options: {
            sortDesc: [true],
        },
        headers: [
            {text: 'Hóspede', value: 'guestName', sortable: false},
            {text: 'Qtd de Reservas Confirmadas', value: 'totalGuestBookings', sortable: true},
            {text: 'Diárias (média)', value: 'avgBookedDays', sortable: true},
        ]
    }),

    methods: {
        pushQueryToRouter() {
            if (!this.hideQuery) {
                this.$router.push({
                    query: {
                        'page': this.options.page,
                        'perPage': this.options.itemsPerPage,
                        'sortBy': this.options.sortBy,
                        'sortDesc': this.options.sortDesc,
                        'guestName': this.filter.guestName,
                        'createdStartDate': this.filter.createdStartDate,
                        'createdUntilDate': this.filter.createdUntilDate,
                    }
                });
            }
        },

        setQueryString() {
            this.query = `page=${this.options.page}&perPage=${this.options.itemsPerPage}&sortBy=${this.options.sortBy}&sortDesc=${this.options.sortDesc}&limit=${this.limit ?? ''}` +
                `&guestName=${this.filter.guestName}&createdStartDate=${this.filter.createdStartDate}&createdUntilDate=${this.filter.createdUntilDate}`;
        },

        setFilter(filter) {
            this.filter = {
                'guestName': filter.guestName ?? '',
                'createdStartDate': filter.createdStartDate ?? filter.startDate ?? '',
                'createdUntilDate': filter.createdUntilDate ?? filter.finalDate ?? '',
            };
        },

        getReportData(filter = {}) {
            this.reportTableLoading = true;
            this.setFilter(filter);
            this.setQueryString();
            this.pushQueryToRouter();
            axios.get(`/api/reports/guest?${this.query}`)
                .then(res => {
                    this.guestReportData = res.data.data;
                    this.total = res.data.total;
                    this.reportTableLoading = false;
                })
        },

        getFooterProps() {
            if (this.hideFooter) {
                return {itemsPerPageOptions: [10]};
            }
            return {itemsPerPageOptions: [10, 15, 30]};
        },

        getOptionsFromUrlQuery() {
            if(Object.keys(this.$route.query).length) {
                const {
                    page,
                    perPage,
                    sortBy,
                    sortDesc,
                } = this.$route.query;
                if (page) {
                    this.options.page = parseInt(page ? page : 1);
                }
                if (perPage) {
                    this.options.itemsPerPage = perPage;
                }
                if (sortBy) {
                    this.options.sortBy = sortBy;
                }
                if (sortDesc) {
                    this.options.sortDesc = sortDesc;
                }
            }
        },
    },

    mounted() {
        this.getOptionsFromUrlQuery();
    },

    watch: {
        options: {
            handler: function() {
                if (!this.hideQuery) {
                    this.getReportData(this.filter);
                }
            },
            deep: true
        }
    },
}
</script>

<style scoped>

</style>
